import { render, staticRenderFns } from "./RemoteUpgrade.vue?vue&type=template&id=12970c16&scoped=true"
import script from "./RemoteUpgrade.vue?vue&type=script&lang=js"
export * from "./RemoteUpgrade.vue?vue&type=script&lang=js"
import style0 from "./RemoteUpgrade.vue?vue&type=style&index=0&id=12970c16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12970c16",
  null
  
)

export default component.exports